import { formatNumber, formatPercent } from "../../../../utils/format";

/**
 * Hand-coded horizontal funnel — each stage is a row whose colored bar width
 * is proportional to its count. Colors come straight from pipeline_stages.color.
 * Avoids Recharts here because the funnel needs exact color + label control.
 */
const PipelineFunnel = ({ stages = [], loading }) => {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="h-11 rounded-md bg-gray-100 animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (!stages || stages.length === 0) {
    return (
      <div className="text-sm text-gray-500 py-8 text-center">
        Chưa có giai đoạn nào
      </div>
    );
  }

  const maxCount = Math.max(1, ...stages.map((s) => Number(s.count) || 0));
  const totalCount = stages.reduce((sum, s) => sum + (Number(s.count) || 0), 0);

  return (
    <div className="space-y-1.5">
      {stages.map((s) => {
        const count = Number(s.count) || 0;
        const widthPct = Math.max(2, (count / maxCount) * 100);
        const pctOfTotal = formatPercent(count, totalCount);
        return (
          <div
            key={s.id ?? "unassigned"}
            className="relative h-11 rounded-md overflow-hidden bg-gray-50"
            title={`${s.name}: ${formatNumber(count)} (${pctOfTotal})`}
          >
            <div
              className="absolute inset-y-0 left-0 rounded-md flex items-center px-3"
              style={{
                width: `${widthPct}%`,
                backgroundColor: s.color || "#9ca3af",
              }}
            >
              <span className="text-xs font-semibold text-white truncate drop-shadow-sm">
                {s.name}
              </span>
            </div>
            <div className="absolute inset-y-0 right-3 flex items-center gap-1 text-xs font-semibold text-gray-900 tabular-nums">
              {formatNumber(count)}
              <span className="text-gray-500 font-normal">
                · {pctOfTotal}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PipelineFunnel;
